import { render } from "./NewProductGroup.vue?vue&type=template&id=b6cf28e2"
import script from "./NewProductGroup.vue?vue&type=script&lang=js"
export * from "./NewProductGroup.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__